import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-campaigns-performance',
    templateUrl: './campaigns-performance.component.html',
    styleUrls: ['./campaigns-performance.component.scss']
})
export class CampaignsPerformanceComponent implements OnInit {
    public barChartLabels = ['1', '2', '3', '4', '5', '6', '7'];
    public data = [5600, 2355, 9230, 7356, 1856, 3983, 6666];
    constructor() {}

    ngOnInit() {}
}
